
<template>
  <v-app id="onKlav">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{klav.klav_nr}} - {{klav.klav_oms}} -  {{klav.kavr_oms}}   <!-- <v-btn text @click="klavView()">View</v-btn> <br> -->

      <span v-for="(kavrtaalRecord,i) in klav.kavrtaal" :key="i">
       <br>
       {{kavrtaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="savekavrtaal(kavrtaalRecord)">Save</v-btn><br>
       <v-textarea v-model="kavrtaalRecord.kavrtaal_oms" :value=kavrtaalRecord.kavrtaal_oms rows="10" label="Print text"></v-textarea>
       <br>
        
      </span>
     
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['klav_encrid'],
  data() {
    return {
      klav: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/klav/getKlav.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKlav"
          },
          getKlav: {
             klav_encrid: this.klav_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.klav = res.data.getKlav;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    savekavrtaal(kavrtaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/klav/saveKavrtaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveKavrtaal"
          },
          saveKavrtaal: {
            kavrtaal: kavrtaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveKavrtaal.text,
              color: res.data.saveKavrtaal.color
            });
          }
        })
    }
  }  

};

</script> 
